import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BusyService } from '@tgbot/app/services/busy.service';

@Component({
  selector: 'crm-tgbot-busy-loader',
  imports: [MatProgressSpinnerModule],
  templateUrl: './busy-loader.component.html',
  styleUrl: './busy-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusyLoaderComponent {
  busyService = inject(BusyService);
}
